/**
 * 设备指纹工具类
 * 生成：24 位 大小写+数字 唯一短指纹
 * 同一设备/浏览器永久不变
 */

// 生成浏览器原始特征哈希
async function getBrowserFingerprintHash() {
  const features = [];
  features.push(navigator.userAgent || "");
  features.push(navigator.language || "");
  features.push(navigator.platform || "");
  features.push(navigator.hardwareConcurrency || 0);
  features.push(screen.width + "x" + screen.height);
  features.push(screen.colorDepth || 0);
  features.push(new Date().getTimezoneOffset());

  // Canvas 核心指纹（加 try-catch 防报错）
  try {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (ctx) {
      ctx.textBaseline = "top";
      ctx.font = "14px Arial";
      ctx.fillText("device-unique-id", 2, 2);
      features.push(canvas.toDataURL());
    } else {
      features.push("canvas-not-supported");
    }
  } catch (e) {
    features.push("canvas-error");
  }

  console.log("指纹特征列表:", features);

  // 校验 crypto.subtle 可用性
  if (!window.crypto || !window.crypto.subtle) {
    throw new Error("当前环境不支持 crypto.subtle");
  }

  const msgBuffer = new TextEncoder().encode(features.join("|"));
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
  return new Uint8Array(hashBuffer);
}

// 二进制转 62 进制短字符串（永不 undefined）
function bufferToShortFP(buffer) {
  const chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

  let num = 0n;
  for (const byte of buffer) {
    num = (num << 8n) | BigInt(byte);
  }

  let str = "";
  while (num > 0n) {
    const idx = num % 62n;
    str = chars[Number(idx)] + str;
    num = num / 62n;
  }

  // 固定截取 24 位
  let result = str.padStart(24, "0").slice(0, 24);
  return result || "unknownDevice2025";
}

// 对外暴露：获取设备指纹（带缓存+降级）
export async function getDeviceFingerprint() {
  try {
    // 读取缓存
    let fp = localStorage.getItem("deviceFingerprint");
    if (fp) return fp;

    // 生成新指纹
    const hashBuffer = await getBrowserFingerprintHash();
    fp = bufferToShortFP(hashBuffer);

    // 存入本地
    localStorage.setItem("deviceFingerprint", fp);
    return fp;
  } catch (err) {
    console.error("设备指纹生成失败", err);
    // 降级方案：返回一个唯一的24位字符串
    return "err" + Date.now().toString(36).slice(-7).padEnd(24, "0");
  }
}